module.exports = __webpack_public_path__ + "img/logo.04a951d4.svg";